import React from "react";
import { Spin, Tag } from "antd";
import moment from "moment";

import { useGetInfiniteNotes } from "services/hooks/useGetInfiniteNotes";

const NotesComponent = (props) => {
  const { profileUsername, userProfileUsername, type, infoTabHeight } = props;
  const userData = {
    main_username: userProfileUsername,
    second_username: profileUsername,
  };
  const profileData = {
    main_username: profileUsername,
    second_username: userProfileUsername,
  };
  const { data, isError } = useGetInfiniteNotes(
    type === "user" ? userData : profileData
  );

  const renderNotes = (item) => {
    return (
      <div className="MemoContainer" key={item.created_at}>
        <div className="CommenterInfo">
          <Tag color={item.type === "IMPORTANT" ? "red" : "blue"}>
            {item.label}
          </Tag>
          {/* <div className="CommenterName">{item.username}</div> */}
          <div className="CommenterTime">
            {moment(item.created_at).format("MM-D-YYYY, HH:mm")}
          </div>
        </div>
        <div className="MemoBody">{item.body}</div>
      </div>
    );
  };

  return (
    <div className="MemoTab" style={{ height: infoTabHeight }}>
      <div className="MemosContainer">
        {data ? (
          data[0].length > 0 ? (
            data[0].map((item) => {
              return renderNotes(item);
            })
          ) : (
            <div>No notes</div>
          )
        ) : isError ? (
          <div>Error loading data</div>
        ) : (
          <Spin />
        )}
      </div>
    </div>
  );
};

export default NotesComponent;
